import { render, staticRenderFns } from "./SupplierManufacturingAllergens.vue?vue&type=template&id=81d9b646&scoped=true&"
import script from "./SupplierManufacturingAllergens.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingAllergens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d9b646",
  null
  
)

export default component.exports